import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureFlaggingService } from 'src/app/feature-flagging/feature-flagging.service';
import { FeatureFlags } from 'src/app/feature-flagging/feature-flags';
import { ActivityTypesResponse } from 'src/app/models/interactive-activity/interactive-activity.model';
import { ListParams } from 'src/app/models/list-params/list-params.model';
import { InteractiveActivityTypesService } from 'src/app/services/interactive-activity-types.service';
import { CopyToClipboardModule } from 'src/app/shared/copy-to-clipboard/copy-to-clipboard.module';
import { TextfieldComponent } from 'src/app/shared/form/textfield/textfield.component';
import { ListViewModule } from 'src/app/shared/list/list-view/list-view.module';
import { LoaderComponent } from 'src/app/shared/loader/loader.component';

@Component({
  selector: 'app-ia-types',
  templateUrl: './interactive-activity-types.component.html',
  styleUrls: ['./interactive-activity-types.component.scss'],
  imports: [CommonModule, CopyToClipboardModule, ListViewModule, LoaderComponent, RouterModule, TextfieldComponent],
})
export class InteractiveActivityTypesComponent implements OnInit {
  private readonly featureFlaggingService = inject(FeatureFlaggingService);
  private readonly iaTypesService = inject(InteractiveActivityTypesService);

  get canManageIaTypes(): boolean {
    return this.featureFlaggingService.isFeatureEnabled(FeatureFlags.CAN_CREATE_EDIT_INTERACTIVE_ACTIVITY_TYPES);
  }

  activityTypesHeader: { label: string; key?: string; sortable?: boolean }[] = [
    { label: 'Name', key: 'name', sortable: false },
    { label: 'Date Created', key: 'dateCreated', sortable: false },
    { label: 'Activity Build URL', key: 'activityUrl', sortable: false },
    { label: 'Is Custom HTML?', key: 'isCustomHtml', sortable: false },
    { label: 'Actions' },
  ];

  activitiesList?: ActivityTypesResponse;
  loading = false;
  searchTerm = '';
  currentPage = 1;
  sorting = false;
  sortingParams?: { key?: string; asc?: boolean };

  ngOnInit(): void {
    this.loadInteractiveActivityTypes();
  }

  loadInteractiveActivityTypes(hideLoader?: boolean) {
    var params: ListParams = { page: this.currentPage };
    if (this.searchTerm) {
      params.text = this.searchTerm;
    }

    if (this.sortingParams) {
      params.orderBy = this.sortingParams.key;
      params.sort = this.sortingParams.asc ? 'asc' : 'desc';
    }

    if (!hideLoader) {
      this.loading = true;
    }

    this.iaTypesService.list().subscribe((iaTypes: ActivityTypesResponse) => {
      iaTypes.interactiveActivityTypes.forEach(iaType => {
        iaType.createdAt = new Date(iaType.createdAt).toLocaleDateString('en-US');
      });
      this.activitiesList = iaTypes;
      this.loading = false;
      this.sorting = false;
    });
  }

  onSearchChange(term: string) {
    this.searchTerm = term;
    this.currentPage = 1;
    this.loadInteractiveActivityTypes();
  }

  onPageChange(newPage: number) {
    this.currentPage = newPage;
    this.loadInteractiveActivityTypes();
  }

  onSortChange(params: { key: string; asc: boolean }) {
    this.sorting = true;
    this.sortingParams = params;
    this.loadInteractiveActivityTypes(true);
  }
}
